import { apiSlice } from "../apiSlice";

const secondaryUrl = "";
const testExtendedSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    setTimeZone: builder.mutation({
      query: ({ time_zone }) => ({
        url: `${secondaryUrl}/settimezone.webapi`,
        method: "POST",
        body: { time_zone: time_zone },
      }),
    }),
    setTheme: builder.mutation({
      query: ({ theme }) => ({
        url: `${secondaryUrl}/updatetheme.webapi`,
        method: "POST",
        body: { theme },
      }),
    }),
    setPassword: builder.mutation({
      query: ({ password }) => ({
        url: `${secondaryUrl}/changepassword.webapi`,
        method: "POST",
        body: { ...password },
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ email }) => ({
        url: `${secondaryUrl}/resetpassword.webapi`,
        method: "POST",
        body: { email: email },
      }),
    }),
    signUpToDemo: builder.mutation({
      query: ({ details }) => ({
        url: `${secondaryUrl}/demosignup.webapi`,
        method: "POST",
        body: { ...details },
      }),
    }),
    updateWarnings: builder.mutation({
      query: ({ warnings }) => ({
        url: `${secondaryUrl}/updatewarnings.webapi`,
        method: "POST",
        body: { warnings: warnings },
      }),
    }),
    getuserstats: builder.query({
      query: () => ({
        url: "getuserstats.webapi/",
      }),
    }),
    //Tutor and Timed are independent; send both
    updatetestmode: builder.mutation({
      query: ({
        tutor_mode,
        timed_mode,
      }: {
        tutor_mode: boolean;
        timed_mode: boolean;
      }) => ({
        url: `${secondaryUrl}/updatetestmode.webapi`,
        method: "POST",
        body: { tutor_mode, timed_mode },
      }),
    }),
    updateTestSettings: builder.mutation({
      query: ({ settings }) => ({
        url: `${secondaryUrl}/updatetestsettings.webapi`,
        method: "POST",
        body: { settings },
      }),
    }),
    updateCreateTestSettings: builder.mutation({
      query: ({ settings }) => ({
        url: `${secondaryUrl}/updatecreatetestsettings.webapi`,
        method: "POST",
        body: { settings },
      }),
    }),
    grabCategoryCounts: builder.query({
      query: () => ({
        url: `${secondaryUrl}/getcategories.webapi`,
      }),
    }),
    updateToothNotation: builder.mutation({
      query: (data) => ({
        url: "/updatetoothnotation.webapi",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useSetTimeZoneMutation,
  useSetPasswordMutation,
  useSetThemeMutation,
  useResetPasswordMutation,
  useSignUpToDemoMutation,
  useUpdateWarningsMutation,
  useUpdatetestmodeMutation,
  useGetuserstatsQuery,
  useGrabCategoryCountsQuery,
  useUpdateTestSettingsMutation,
  useUpdateCreateTestSettingsMutation,
  useUpdateToothNotationMutation,
} = testExtendedSlice;
